import apiClient from './api.service';

const UserService = {
  // Get all users
  getAllUsers() {
    return apiClient.get('/auth/users');
  },

  // Get user by ID
  getUserById(id) {
    return apiClient.get(`/auth/getuser/${id}`);
  },

  // Update user profile
  updateUser(id, data) {
    return apiClient.patch(`/auth/profile/${id}`, data);
  },

  // Get users by type (0 = student, 1 = teacher)
  getUsersByType(type) {
    return apiClient.get(`/auth/users?user_type=${type}`);
  },

  // Verify user account (admin action)
  verifyUser(userId, verificationData) {
    return apiClient.post(`/auth/admin/verify-user/${userId}`, verificationData);
  },

  // Suspend/Ban user
  suspendUser(userId, reason) {
    return apiClient.post(`/auth/admin/suspend-user/${userId}`, { reason });
  },

  // Activate suspended user
  activateUser(userId) {
    return apiClient.post(`/auth/admin/activate-user/${userId}`);
  },

  // Get user statistics
  getUserStats() {
    return apiClient.get('/auth/admin/user-stats');
  },

  // Edit a user's email, phone and full profile (name, location,
  // role-specific fields, ...) as an admin.
  adminUpdateUser(userId, data) {
    return apiClient.patch(`/auth/admin/update-user/${userId}`, data);
  }
};

export default UserService;
